import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Container,
  Paper,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

import { useUser } from '../../../contexts/UserContext';
import SendTab from './SendTab';
import ForwarderTargetsTab from './ForwarderTargetsTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div hidden={value !== index} role="tabpanel">
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ForwardMail() {
  const { user } = useUser();
  const [tab, setTab] = useState(0);

  useEffect(() => {
    document.title = 'Forward Mail — Marketing Portal';
  }, []);

  if (!user?.is_admin) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">Admin access required.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Forward Mail
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Send mail AS, and configure the inbound forwarders for, the domains that
        have no real mailbox (captablehero.com, vowsandvideo.com, abocevents.com).
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          aria-label="forward mail tabs"
        >
          <Tab label="Send Email" id="fwd-tab-0" aria-controls="fwd-panel-0" />
          <Tab
            label="Forwarder Targets"
            id="fwd-tab-1"
            aria-controls="fwd-panel-1"
          />
        </Tabs>

        <Box sx={{ p: 3 }}>
          <TabPanel value={tab} index={0}>
            <SendTab />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <ForwarderTargetsTab />
          </TabPanel>
        </Box>
      </Paper>
    </Container>
  );
}
